import { useEffect, useState } from "react";
import Api from "../../utils/Api";
import { API_ROUTE_DISPLAY_MEDIA_TYPES } from "../../routes";

export default function useGetDisplayMediaTypes(auto = false) {
  const [displayMediaTypes, setDisplayMediaTypes] = useState([]);

  const getDisplayMediaTypes = () => {
    Api.get(API_ROUTE_DISPLAY_MEDIA_TYPES).then((res) => {
      setDisplayMediaTypes(res.data);
    });
  };

  useEffect(() => {
    if (!auto) {
      return;
    }
    getDisplayMediaTypes();
  }, [auto]);

  return {
    displayMediaTypes,
    getDisplayMediaTypes,
  };
}
